import React, { useEffect, useState } from 'react';
import { MAIN_URL } from '../../constants';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../../Components/RefreshToken/RefreshToken';
import axios from 'axios';
import { toast } from 'react-toastify';
import NewCourse from '../AddLesson/index';
import Loader from '../Loader/index';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const langFlags = { uz: "🇺🇿", ru: "🇷🇺", en: "🇬🇧" };

const UpdateLessons = () => {
    const location   = useLocation();
    const navigate   = useNavigate();
    const lessonId   = location.state?.lessonId  || "";
    const chapterId  = location.state?.chapterId || "";
    const courseId   = location.state?.courseId  || "";
    const TOKEN      = localStorage.getItem("admin_token");
    const updateVideoUrl = localStorage.getItem("updateVideoUrl");

    // ─── UI ──────────────────────────────────────────────────────────────────────
    const [imgOpen,       setImgOpen]       = useState(false);
    const [isHovered,     setIsHovered]     = useState(false);
    const [isHoveredFile, setIsHoveredFile] = useState(false);
    const [openGenerate,  setOpenGenerate]  = useState(false);
    const [openStatus,    setOpenStatus]    = useState(false);

    // ─── Lesson asosiy ma'lumotlari ───────────────────────────────────────────────
    // PUT /courses/lessons/update/{lesson_id}  → faqat photo + chapter_id
    const [lesson,           setLesson]           = useState(null);
    const [image,            setImage]            = useState("");
    const [addImgChange,     setAddImgChange]      = useState(null);
    const [selectedChapterId, setSelectedChapterId] = useState(chapterId || "");
    const [chapters,         setChapters]          = useState([]);

    // ─── Translations ─────────────────────────────────────────────────────────────
    // PUT /courses/lessons/translations/{translation_id}/update
    // body: multipart/form-data — video_url*, title*, description*, pdf?, indpndnt_lrng_pdf?
    const [activeLanguage, setActiveLanguage] = useState("uz");
    const [translations, setTranslations] = useState({
        uz: { title: "", description: "", video_url: "", pdf_url: "", indpndnt_lrng_pdf: "", translation_id: null, pdfFile: null, indpndntFile: null },
        ru: { title: "", description: "", video_url: "", pdf_url: "", indpndnt_lrng_pdf: "", translation_id: null, pdfFile: null, indpndntFile: null },
        en: { title: "", description: "", video_url: "", pdf_url: "", indpndnt_lrng_pdf: "", translation_id: null, pdfFile: null, indpndntFile: null },
    });

    // video replace
    const [activeButton, setActiveButton] = useState("new");

    // ─── Lesson detail ────────────────────────────────────────────────────────────
    // Response: { id, photo, chapter_id, translations: [{id, title, description, pdf_url, indpndnt_lrng_pdf, video_url, language}] }
    useEffect(() => {
        if (!lessonId) return;
        api.get(`/courses/lessons/${lessonId}`, {
            headers: { Authorization: `Bearer ${TOKEN}` }
        }).then((res) => {
            const data = res.data;
            setLesson(data);
            setImage(data.photo || "");
            setSelectedChapterId(data.chapter_id || chapterId);

            // translations massividan state ga yozamiz
            if (Array.isArray(data.translations)) {
                const mapped = {
                    uz: { title: "", description: "", video_url: "", pdf_url: "", indpndnt_lrng_pdf: "", translation_id: null, pdfFile: null, indpndntFile: null },
                    ru: { title: "", description: "", video_url: "", pdf_url: "", indpndnt_lrng_pdf: "", translation_id: null, pdfFile: null, indpndntFile: null },
                    en: { title: "", description: "", video_url: "", pdf_url: "", indpndnt_lrng_pdf: "", translation_id: null, pdfFile: null, indpndntFile: null },
                };
                data.translations.forEach((t) => {
                    if (mapped[t.language] !== undefined) {
                        mapped[t.language] = {
                            title:            t.title            || "",
                            description:      t.description      || "",
                            video_url:        t.video_url        || "",
                            pdf_url:          t.pdf_url          || "",
                            indpndnt_lrng_pdf: t.indpndnt_lrng_pdf || "",
                            translation_id:   t.id,
                            pdfFile:          null,
                            indpndntFile:     null,
                        };
                    }
                });
                setTranslations(mapped);

                // default: birinchi mavjud tilni ochiq qilamiz
                const firstLang = data.translations[0]?.language;
                if (firstLang) setActiveLanguage(firstLang);
            }
        }).catch((err) => console.log("error fetching lesson", err));
    }, [lessonId]);

    // updateVideoUrl localStorage dan kelganda aktiv tilning video_url ni yangilaymiz
    useEffect(() => {
        if (updateVideoUrl && activeLanguage) {
            setTranslations(prev => ({
                ...prev,
                [activeLanguage]: { ...prev[activeLanguage], video_url: updateVideoUrl }
            }));
        }
    }, [updateVideoUrl]);

    // ─── Chapters (chapter_id select uchun) ──────────────────────────────────────
    useEffect(() => {
        if (!courseId) return;
        api.get(`/courses/chapters`, {
            params: { course_id: courseId },
            headers: { Authorization: `Bearer ${TOKEN}` }
        }).then((res) => setChapters(res.data))
        .catch((err) => console.log(err));
    }, []);

    // ─── Handlers ────────────────────────────────────────────────────────────────
    const handleImgOpen   = () => setImgOpen(x => !x);
    const handleImgChange = (e) => {
        const file = e.target.files[0];
        if (file) { setAddImgChange(file); setImage(URL.createObjectURL(file)); }
    };

    const handleTranslationChange = (lang, field, value) => {
        setTranslations(prev => ({ ...prev, [lang]: { ...prev[lang], [field]: value } }));
    };

    const handlePdfChange = (lang, field, e) => {
        const file = e.target.files[0];
        if (file) {
            setTranslations(prev => ({ ...prev, [lang]: { ...prev[lang], [field]: file } }));
        }
    };

    // ─── 1. Asosiy lesson yangilash: faqat photo + chapter_id ────────────────────
    // PUT /courses/lessons/update/{lesson_id}
    const updateLessonBase = () => {
        const formData = new FormData();
        formData.append("chapter_id", selectedChapterId);
        if (addImgChange) formData.append("photo", addImgChange);

        axios.put(`${MAIN_URL}/courses/lessons/update/${lessonId}`, formData, {
            headers: { Authorization: `Bearer ${TOKEN}`, "Content-Type": "multipart/form-data" }
        }).then(() => {
            toast.success("Lesson asosiy ma'lumotlari saqlandi!");
        }).catch((err) => {
            toast.error("Xatolik yuz berdi!");
            console.log(err);
        });
    };

    // ─── 2. Translation yangilash: title + description + video_url + pdf? ────────
    // PUT /courses/lessons/translations/{translation_id}/update
    const updateTranslation = (lang) => {
        const t = translations[lang];
        if (!t.translation_id) {
            toast.warning(`${lang.toUpperCase()} translation ID topilmadi!`);
            return;
        }
        if (!t.title.trim())     { toast.warning("Title bo'sh bo'lishi mumkin emas!"); return; }
        if (!t.video_url.trim()) { toast.warning("Video URL bo'sh bo'lishi mumkin emas!"); return; }

        const formData = new FormData();
        formData.append("title",       t.title);
        formData.append("description", t.description);
        formData.append("video_url",   t.video_url);
        if (t.pdfFile)      formData.append("pdf",               t.pdfFile);
        if (t.indpndntFile) formData.append("indpndnt_lrng_pdf", t.indpndntFile);

        axios.put(
            `${MAIN_URL}/courses/lessons/translations/${t.translation_id}/update`,
            formData,
            { headers: { Authorization: `Bearer ${TOKEN}`, "Content-Type": "multipart/form-data" } }
        ).then(() => {
            toast.success(`${langFlags[lang]} ${lang.toUpperCase()} saqlandi!`);
            localStorage.removeItem("updateVideoUrl");
        }).catch((err) => {
            toast.error(`Xatolik: ${err.message}`);
            console.log(err);
        });
    };

    // video replace
    const replaceVideo = () => {
        sessionStorage.setItem("replaceVid", "open generate");
        sessionStorage.setItem("lessonId", lessonId);
        setOpenGenerate(true);
    };
    const regenerateId = sessionStorage.getItem("lessonId");

    useEffect(() => {
        if (!openGenerate) sessionStorage.removeItem("replaceVid");
    }, [openGenerate]);

    // aktiv tilning video va pdf url lari
    const activeTr = translations[activeLanguage];

    // Chapter select uchun title — chapter.translations dan olamiz (yoki chapter.title)
    const getChapterTitle = (chapter) => {
        if (chapter.title) return chapter.title;
        if (Array.isArray(chapter.translations) && chapter.translations.length > 0) {
            return chapter.translations.find(t => t.language === "uz")?.title
                || chapter.translations[0]?.title
                || `Chapter ${chapter.id}`;
        }
        return `Chapter ${chapter.id}`;
    };

    return (
        <div className='confirm-lesson'>
            <h4 className="confirm-lesson-title">Edit Lesson</h4>

            {/* ─── Asosiy: photo + chapter_id ──────────────────────────────────── */}
            <div className="update-block">
                <div className="ul-base-section">
                    <h5 className="ul-section-title">
                        <i className="ri-settings-3-line"></i> Asosiy ma'lumotlar
                    </h5>
                    <div className="ul-base-row">
                        {/* Rasm */}
                        <div className="ul-img-wrap">
                            <span className="ul-label">Rasm</span>
                            <div
                                className="edit-img-block update-lesson-img"
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                            >
                                {image && (
                                    <img
                                        className='edit-img'
                                        src={image.startsWith("blob") || image.startsWith("http") ? image : `${MAIN_URL}/${image}`}
                                        alt="Lesson"
                                    />
                                )}
                                <div className={`img-hover-block ${isHovered ? "show" : ""}`}>
                                    <div onClick={handleImgOpen} className="view-icon">
                                        <i className="ri-eye-fill black-color"></i>
                                    </div>
                                    <label className="edit-icon">
                                        <i className="ri-pencil-fill black-color"></i>
                                        <input onChange={handleImgChange} className='edit-img-input' accept="image/*" type="file" />
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Chapter tanlash */}
                        <div className="ul-chapter-wrap">
                            <span className="ul-label">Chapter</span>
                            <select
                                className="select-chapter"
                                value={selectedChapterId}
                                onChange={e => setSelectedChapterId(e.target.value)}
                            >
                                {chapters.map((ch) => (
                                    <option key={ch.id} value={ch.id}>
                                        {getChapterTitle(ch)}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Asosiy save tugmasi */}
                    <div className="ul-save-row">
                        <button onClick={updateLessonBase} className="confirmation-btn saveBtn">
                            <i className="ri-save-line"></i> Save
                        </button>
                    </div>
                </div>
            </div>

            {/* ─── Translations: title + description + video + pdf ─────────────── */}
            <div className="translations-block">
                <h5 className="translations-title">
                    <i className="ri-translate-2"></i> Translations
                </h5>

                {/* Til tablari */}
                <div className="lang-tabs">
                    {["uz", "ru", "en"].map((lang) => (
                        <button
                            key={lang}
                            type="button"
                            className={`lang-tab ${activeLanguage === lang ? "lang-tab--active" : ""}`}
                            onClick={() => setActiveLanguage(lang)}
                        >
                            {langFlags[lang]} {lang.toUpperCase()}
                            <span className={translations[lang].translation_id ? "lang-dot" : "lang-dot lang-dot--missing"} />
                        </button>
                    ))}
                </div>

                {/* Har bir til uchun form */}
                {["uz", "ru", "en"].map((lang) => {
                    const tr = translations[lang];
                    return (
                        <div key={lang} style={{ display: activeLanguage === lang ? "block" : "none" }}>

                            {/* Bu til backendda yo'q */}
                            {!tr.translation_id ? (
                                <div className="ct-no-translation">
                                    <i className="ri-information-line"></i>
                                    <span>{lang.toUpperCase()} tarjimasi hali mavjud emas</span>
                                </div>
                            ) : (
                                <>
                                    {/* Video */}
                                    <div className="ul-video-section">
                                        <video
                                            className='update-video'
                                            src={tr.video_url}
                                            controls
                                            key={tr.video_url}
                                        />
                                        <div className="update-btns">
                                            <button onClick={replaceVideo} className='replece-video'>
                                                <i className="ri-refresh-line"></i> Re Generate
                                            </button>
                                            {updateVideoUrl && regenerateId == lessonId && (
                                                <div style={{ display: "flex", gap: "8px" }}>
                                                    <button
                                                        onClick={() => {
                                                            handleTranslationChange(lang, "video_url", lesson?.translations?.find(t => t.language === lang)?.video_url || "");
                                                            setActiveButton("old");
                                                        }}
                                                        className={`replece-video ${activeButton === "old" ? "activeBtn" : ""}`}
                                                    >
                                                        Old Video
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            handleTranslationChange(lang, "video_url", updateVideoUrl);
                                                            setActiveButton("new");
                                                        }}
                                                        className={`replece-video ${activeButton === "new" ? "activeBtn" : ""}`}
                                                    >
                                                        New Video
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="translation-fields" style={{ marginTop: "20px" }}>
                                        {/* Title */}
                                        <div className="translation-field">
                                            <span>Title ({lang.toUpperCase()})</span>
                                            <input
                                                type="text"
                                                className="edit-title bac-input"
                                                value={tr.title}
                                                onChange={(e) => handleTranslationChange(lang, "title", e.target.value)}
                                                placeholder={`${lang.toUpperCase()} tilida sarlavha...`}
                                            />
                                        </div>

                                        {/* Description */}
                                        <div className="translation-field">
                                            <span>Description ({lang.toUpperCase()})</span>
                                            <ReactQuill
                                                value={tr.description}
                                                onChange={(val) => handleTranslationChange(lang, "description", val)}
                                                className="back-input"
                                                placeholder={`${lang.toUpperCase()} tilida tavsif...`}
                                            />
                                        </div>

                                        {/* PDF va Independent Learning PDF */}
                                        <div className="ul-pdf-row">
                                            {/* Lesson PDF */}
                                            <div className="translation-field ul-pdf-field">
                                                <span>Lesson PDF</span>
                                                <div
                                                    className="edit-img-block update-lesson-img"
                                                    onMouseEnter={() => setIsHoveredFile(true)}
                                                    onMouseLeave={() => setIsHoveredFile(false)}
                                                >
                                                    <div className="edit-img pdf-edit-block">
                                                        <span className='pdf-edit'>
                                                            <i style={{ marginRight: "8px" }} className="ri-folder-fill"></i>
                                                            {tr.pdfFile
                                                                ? (tr.pdfFile.name.length > 18 ? tr.pdfFile.name.slice(0, 18) + "..." : tr.pdfFile.name)
                                                                : (tr.pdf_url ? "PDF mavjud" : "PDF yo'q")}
                                                        </span>
                                                    </div>
                                                    <div className={`img-hover-block ${isHoveredFile ? "show" : ""}`}>
                                                        {tr.pdf_url && (
                                                            <a target='_blank' href={tr.pdf_url} download className='view-icon href'>
                                                                <i className="ri-eye-fill black-color"></i>
                                                            </a>
                                                        )}
                                                        <label className="edit-icon">
                                                            <i className="ri-pencil-fill black-color"></i>
                                                            <input
                                                                type="file"
                                                                accept=".pdf"
                                                                style={{ display: "none" }}
                                                                onChange={(e) => handlePdfChange(lang, "pdfFile", e)}
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Independent Learning PDF */}
                                            <div className="translation-field ul-pdf-field">
                                                <span>Independent Learning PDF</span>
                                                <div className="edit-img-block update-lesson-img">
                                                    <div className="edit-img pdf-edit-block">
                                                        <span className='pdf-edit'>
                                                            <i style={{ marginRight: "8px" }} className="ri-book-open-fill"></i>
                                                            {tr.indpndntFile
                                                                ? (tr.indpndntFile.name.length > 18 ? tr.indpndntFile.name.slice(0, 18) + "..." : tr.indpndntFile.name)
                                                                : (tr.indpndnt_lrng_pdf ? "PDF mavjud" : "PDF yo'q")}
                                                        </span>
                                                    </div>
                                                    <div className="img-hover-block show-on-hover">
                                                        {tr.indpndnt_lrng_pdf && (
                                                            <a target='_blank' href={tr.indpndnt_lrng_pdf} download className='view-icon href'>
                                                                <i className="ri-eye-fill black-color"></i>
                                                            </a>
                                                        )}
                                                        <label className="edit-icon">
                                                            <i className="ri-pencil-fill black-color"></i>
                                                            <input
                                                                type="file"
                                                                accept=".pdf"
                                                                style={{ display: "none" }}
                                                                onChange={(e) => handlePdfChange(lang, "indpndntFile", e)}
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Translation save tugmasi */}
                                    <div className="edit-save" style={{ marginTop: "20px" }}>
                                        <button
                                            type="button"
                                            onClick={() => updateTranslation(lang)}
                                            className="confirmation-btn saveBtn"
                                        >
                                            {langFlags[lang]} Save {lang.toUpperCase()}
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    );
                })}
            </div>

            {/* ─── Rasm modal ──────────────────────────────────────────────────── */}
            {imgOpen && (
                <div onClick={handleImgOpen} className="img-modal">
                    <img
                        className='editImg'
                        src={image.startsWith("blob") || image.startsWith("http") ? image : `${MAIN_URL}/${image}`}
                        alt="img"
                    />
                </div>
            )}

            {/* ─── Video generate modal ─────────────────────────────────────────── */}
            {openGenerate && (
                <div
                    onClick={(e) => { if (e.target === e.currentTarget) setOpenGenerate(false); }}
                    className="replace-video"
                >
                    <div className="replace-video-generate">
                        <NewCourse openStatus={setOpenStatus} isOpenGenerate={setOpenGenerate} />
                    </div>
                </div>
            )}
            {openStatus && (
                <div className="replace-video">
                    <div className="replace-video-generate">
                        <Loader openStatus={setOpenStatus} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default UpdateLessons;